import React from 'react';
import { Col } from 'antd';
import SelectField from '../select-field';
import i18n from '../../i18n';

export default function ConsignorFilterSelect({ isOwnerUser, consignors, selectedConsignor, onChange }) {
  if (!isOwnerUser) return null;

  return (
      <SelectField
        name="consignorFilter"
        placeholder={i18n.t('modals.modalListLoadingSchedule.fields.consignors.placeholder')}
        getErrors={() => {}}
        onChange={onChange}
        style={{ width: '100%' }}
        selectedValue={selectedConsignor}
        values={consignors}
      />
  );
}